import { colors as themeColors } from '../utils/theme';
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import {
    Box,
    Grid,
    TextField,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Button,
    Typography,
    Paper,
    Checkbox,
    FormControlLabel,
    Snackbar,
    Alert
} from '@mui/material';
import { useAuth } from '../context/AuthContext';
import { toProperCase } from '../utils/formatRows';
import { getCurrentFYear } from '../utils/financialYear';

const LeadStatusMaster = ({ id: propId, mode, onPopupCancel, connectionString, initialStatus, user: propsUser, companyId: propsCompanyId }) => {
    const { user, selectedCompany } = useAuth();
    const path = `${connectionString}/api`;
    // const { id } = useParams();
    const { id: routeId } = useParams();
    const id =
        mode === 'edit'
            ? propId
            : routeId;

    const navigate = useNavigate();

    console.log("data", selectedCompany);

    const [categoryOptions, setCategoryOptions] = useState([]);
    const [selectedCategoryId, setSelectedCategoryId] = useState('');
    const [selectedCategoryValue, setSelectedCategoryValue] = useState('');
    const [status, setStatus] = useState('');
    const [color, setColor] = useState(themeColors.neutral.black);
    const [formError, setFormError] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [isDefault, setIsDefault] = useState(false);
    const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

    const CATEGORY_OPTIONS = [
        { value: "Pipeline", label: "Pipeline" },
        { value: "Success", label: "Success" },
        { value: "Onhold", label: "Onhold" },
        { value: "Failed", label: "Failed" },
        { value: "Delay", label: "Delay" }
    ];

    // Safely extract values with fallbacks
    const userId = user?.UserId || null;
    const companyId =
        (mode === 'comp' || mode === 'edit')
            ? propsCompanyId
            : selectedCompany?.CompId;
    const gCompId = selectedCompany?.GCompId || selectedCompany?.CompId || null;
    const fYear = getCurrentFYear();
    const branchId = selectedCompany?.BranchId || null;

    // Fetch Category options from /api/status (same as InquiryForm)
    // useEffect(() => {
    //     if (companyId) {
    //         axios.get(`${path}/status`, { params: { companyId } })
    //             .then(res => {
    //                 const opts = (res.data.data || []).map(o => ({
    //                     LeadStatusID: o.LeadStatusID,
    //                     LeadStatus: o.LeadStatus.trim(),
    //                 }));
    //                 setCategoryOptions(opts);
    //             })
    //             .catch(error => console.error("Error fetching category options:", error));
    //     }
    // }, [companyId, path]);

    // Fetch existing data in edit mode
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(`${path}/leadStatus/getDetails/${id}`);
                const data = await response.json();

                setSelectedCategoryId(data.Category || '');
                setSelectedCategoryValue(data.Category || '');
                setStatus(data.LeadStatus || '');
                setColor(data.Color || themeColors.neutral.black);
                setIsDefault(data.IsDefault === 1); // ✅ THIS IS THE FIX
            } catch (error) {
                console.error('Error fetching details:', error);
            }
        };

        if (mode === 'edit') {
            fetchData();
        }
    }, [id, mode, path]);

    useEffect(() => {
        if ((mode === 'add' || mode === 'comp') && initialStatus) {
            console.log('Pre-filling Status with:', initialStatus);
            setStatus(initialStatus);
        }
    }, [mode, initialStatus]);

    // const handleCategoryChange = (event) => {
    //     const selectedId = event.target.value;
    //     setSelectedCategoryId(selectedId);
    //     const selectedOption = categoryOptions.find(opt => opt.LeadStatusID === selectedId);
    //     setSelectedCategoryValue(selectedOption ? selectedOption.LeadStatus : '');
    // };

    const handleCategoryChange = (event) => {
        const selectedValue = event.target.value;
        setSelectedCategoryId(selectedValue);
        setSelectedCategoryValue(selectedValue);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setFormError('');

        // Validation
        if (!selectedCategoryId) {
            setFormError('Category is required.');
            return;
        }
        if (!status.trim()) {
            setFormError('Status is required.');
            return;
        }

        // Payload matching backend expectations
        const payload = {
            GCompId: gCompId,
            CompId: companyId,
            LeadStatus: status,
            Category: selectedCategoryValue,
            Color: color,
            IsDefault: isDefault ? 1 : 0,
            AddUserId: userId,
            FYear: fYear,
            BranchId: branchId,
        };

        console.log('Payload being sent:', payload);

        try {
            setIsLoading(true);
            if (mode === 'add' || mode === 'comp') {
                const response = await axios.post(`${path}/leadStatus/insert`, payload);
                console.log('Insert response:', response.data);

                // Reset form
                setSelectedCategoryId('');
                setSelectedCategoryValue('');
                setStatus('');
                setColor(themeColors.neutral.black);

                // alert('Data inserted successfully');
                setSnackbar({ open: true, message: 'Data inserted successfully', severity: 'success' });
                if (onPopupCancel) {
                    setTimeout(() => { onPopupCancel() }, 600)
                }
                else {
                    navigate(-1);
                }
            } else {
                const response = await axios.put(`${path}/leadStatus/update/${id}`, payload);
                console.log('Update response:', response.data);

                // alert('Data updated successfully');
                setSnackbar({ open: true, message: 'Data updated successfully', severity: 'success' });
                if (onPopupCancel) {
                    setTimeout(() => { onPopupCancel() }, 600)
                } else {
                    navigate(-1);
                }
            }
        } catch (error) {
            console.error('Submission error:', error);
            const errorMessage = error.response?.data?.message || `Error ${mode === 'add' || mode === 'comp' ? 'inserting' : 'updating'} data`;
            alert(errorMessage);
            setFormError(errorMessage);
        } finally {
            setIsLoading(false);
        }
    };

    const handleCancel = () => {
        if (onPopupCancel) {
            onPopupCancel();
        } else {
            setSelectedCategoryId('');
            setSelectedCategoryValue('');
            setStatus('');
            setColor(themeColors.neutral.black);
            setFormError('');
            navigate(-1);
        }
    };

    return (
        <Paper sx={{ p: 3, maxWidth: 600, mx: 'auto', mt: 4 }}>
            <Typography variant="h4" align="center" gutterBottom sx={{ fontWeight: 'bold', typography: { lg: 'h4', md: 'h4', sm: 'h5', xs: 'h5', }, }} >
                {mode === 'add' || mode === 'comp' ? 'Add New Status' : 'Edit Status'}
            </Typography>
            <form onSubmit={handleSubmit}>
                <Grid container spacing={2}>
                    {/* Category Dropdown */}
                    <Grid item size={{ xs: 12 }}>
                        <FormControl
                            fullWidth
                            size="small"
                            sx={{ '& .MuiInputBase-root': { height: 40 } }}
                            disabled={isLoading}
                            required
                            error={!selectedCategoryId && formError !== ''}
                        >
                            <InputLabel>Category</InputLabel>
                            <Select
                                value={selectedCategoryId}
                                onChange={handleCategoryChange}
                                label="Category"
                            >
                                <MenuItem value="" disabled>Select Category</MenuItem>
                                {CATEGORY_OPTIONS.map((option) => (
                                    <MenuItem key={option.value} value={option.value}>
                                        {option.label}
                                    </MenuItem>
                                ))}
                            </Select>
                            {!selectedCategoryId && formError && (
                                <Typography variant="caption" color="error" sx={{ mt: 0.5 }}>
                                    {formError}
                                </Typography>
                            )}
                        </FormControl>
                    </Grid>

                    {/* Status Field */}
                    <Grid item size={{ xs: 12 }}>
                        <TextField
                            fullWidth
                            label="Status"
                            value={toProperCase(status)}
                            onChange={(e) => setStatus(toProperCase(e.target.value))}
                            required
                            size="small"
                            disabled={isLoading}
                            sx={{ '& .MuiInputBase-root': { height: 40 } }}
                        />
                    </Grid>

                    {/* Redesigned Color Picker */}
                    <Grid item size={{ xs: 12 }}>
                        <Typography variant="body1" gutterBottom fontWeight={500}>
                            Color
                        </Typography>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 3 }}>
                            {/* Large Color Swatch with Native Picker */}
                            <Box
                                sx={{
                                    position: 'relative',
                                    width: 80,
                                    height: 50,
                                    borderRadius: 2,
                                    overflow: 'hidden',
                                    border: '2px solid',
                                    borderColor: 'grey.300',
                                    boxShadow: 2,
                                    cursor: 'pointer',
                                }}
                            >
                                <input
                                    type="color"
                                    value={color}
                                    onChange={(e) => setColor(e.target.value)}
                                    disabled={isLoading}
                                    style={{
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        width: '100%',
                                        height: '100%',
                                        opacity: 0,
                                        cursor: 'pointer',
                                    }}
                                />
                                <Box
                                    sx={{
                                        width: '100%',
                                        height: '100%',
                                        backgroundColor: color,
                                        borderRadius: 1.5,
                                    }}
                                />
                            </Box>

                            {/* Hex Code Input with Color Preview */}
                            <TextField
                                value={color.toUpperCase()}
                                onChange={(e) => {
                                    const val = e.target.value;
                                    if (/^#[0-9A-Fa-f]{0,6}$/.test(val)) {
                                        setColor(val);
                                    }
                                }}
                                size="small"
                                disabled={isLoading}
                                placeholder={themeColors.neutral.black}
                                InputProps={{
                                    startAdornment: (
                                        <Box
                                            sx={{
                                                width: 20,
                                                height: 20,
                                                borderRadius: 1,
                                                backgroundColor: color,
                                                mr: 1,
                                                border: '1px solid',
                                                borderColor: 'grey.400',
                                            }}
                                        />
                                    ),
                                }}
                                sx={{
                                    width: 160,
                                    '& .MuiInputBase-root': { height: 40 },
                                }}
                            />
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={isDefault}
                                        onChange={(e) => setIsDefault(e.target.checked)}
                                    />
                                }
                                label="Set as Default"
                            />
                        </Box>
                        <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>
                            Click the color box to pick or type a hex code.
                        </Typography>
                    </Grid>

                    {/* Error Message */}
                    {formError && (
                        <Grid item size={{ xs: 12 }}>
                            <Typography color="error" align="center">{formError}</Typography>
                        </Grid>
                    )}

                    {/* Buttons */}
                    <Grid item size={{ xs: 12 }} display="flex" justifyContent="center" gap={2}>
                        <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            sx={{ minWidth: 120, height: 40 }}
                            disabled={isLoading}
                        >
                            {isLoading ? 'Processing...' : (mode === 'add' || mode === 'comp' ? 'Save' : 'Update')}
                        </Button>
                        <Button
                            type="button"
                            variant="contained"
                            color="error"
                            sx={{ minWidth: 120, height: 40 }}
                            onClick={handleCancel}
                            disabled={isLoading}
                        >
                            Cancel
                        </Button>
                    </Grid>
                </Grid>
            </form>

            <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} open={snackbar.open} autoHideDuration={3000} onClose={() => setSnackbar({ ...snackbar, open: false })} >
                <Alert onClose={() => setSnackbar({ ...snackbar, open: false })} severity={snackbar.severity} sx={{ width: '100%' }} variant='filled'>
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </Paper>
    );
};

export default LeadStatusMaster;